module.exports = __webpack_public_path__ + "static/media/CornerSplit_Before.3f4b49f9.jpg";